"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHalfWidth = exports.halfWidth = void 0;
const assertString_1 = require("./util/assertString");
exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
function isHalfWidth(str) {
    (0, assertString_1.assertString)(str);
    return exports.halfWidth.test(str);
}
exports.isHalfWidth = isHalfWidth;
